import React from 'react';
import { SFAlertDialog } from 'sfui';
import styles from './ContinueReportModal.module.scss';

export interface ContinueReportModalProps {
  isOpen: boolean;
  onDiscard: () => void;
  onContinue: () => void;
}

const ContinueReportModal = ({
  isOpen,
  onDiscard,
  onContinue
}: ContinueReportModalProps): React.ReactElement<ContinueReportModalProps> => {
  return (
    <SFAlertDialog
      open={isOpen}
      title={'Continue your report?'}
      mobileLargeButtons={true}
      leftAction={{
        label: 'Start New Report',
        buttonProps: {
          onClick: onDiscard
        }
      }}
      rightAction={{
        label: `Continue Report`,
        buttonProps: {
          onClick: onContinue
        }
      }}
    >
      <div className={styles.continueReportModalContent}>
        <p>It looks like you were working on a report earlier.</p>
        <p>Would you like to continue where you left off?</p>
      </div>
    </SFAlertDialog>
  );
};

export default ContinueReportModal;
